import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import CartGql from '@/extensions/shop/store/graphql/queries/ShoppingCart.gql';
import CartWithArticlePivotsGql from '@/extensions/shop/store/graphql/queries/ShoppingCartWithArticlePivots.gql';
// import CartsGql from '@/extensions/shop/store/graphql/queries/Carts.gql';
import CartsPaginatedGql from '@/extensions/shop/store/graphql/queries/ShoppingCartsPaginated.gql';
import CartArticlesPaginatedGql from '@/extensions/shop/store/graphql/queries/CartArticlesPaginated.gql';
import SaveCartGql from '@/extensions/shop/store/graphql/mutations/SaveShoppingCart.gql';
import ProcessCartArticlePaginationBulkActionGql from '@/extensions/shop/store/graphql/mutations/ProcessCartArticlePaginationBulkAction.gql';
// import CreateCartGql from '@/extensions/shop/store/graphql/mutations/CreateCart.gql';
// import UpdateCartGql from '@/extensions/shop/store/graphql/mutations/UpdateCart.gql';
// import DeleteCartGql from '@/extensions/shop/store/graphql/mutations/DeleteCart.gql';

export default {
    fetchCartsPaginated: data =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: CartsPaginatedGql,
                    variables: {
                        // Multistore: the store the admin UI currently has selected; the list
                        // shows its records by default and the store filter widens it again.
                        cms: _.get(data, 'cms') ? parseInt(_.get(data, 'cms')) : null,
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'updated_at'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        link: _.get(data, 'link.route', '/sales/order/'),
                        filters
                    }
                })
                // .then(({ data }) => resolve(data.CO_CartsPaginated))
                .then(({ data }) => resolve(data.CO_ShoppingCartsPaginated))
                .catch(err => reject(err));
        }),
    fetchCartArticlesPaginated: (data, cart) =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: CartArticlesPaginatedGql,
                    variables: {
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'updated_at'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        // link: _.get(data, 'link.route', '/cart/article/'),
                        filters,

                        // custom
                        cart
                    }
                })
                .then(({ data }) => resolve(data.CO_CartArticlesPaginated))
                .catch(err => reject(err));
        }),
    // Which store the record belongs to - all a refused detail page needs to
    // explain itself and offer the switch.

    fetchCart: (id, cmsID = null) => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            let variables = { id: parseInt(id) };
            // Multistore: the record belongs to one store, so it is opened in that
            // store's context - the API refuses it from another one.
            if (cmsID) variables.cms = parseInt(cmsID);

            apolloClient
                .query({
                    query: CartGql,
                    fetchPolicy: 'no-cache',
                    variables
                })
                .then(({ data }) => resolve(data.CO_ShoppingCart))
                .catch(err => reject(err));
        });
    },
    fetchCartWithArticlePivots: id => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            let variables = { id: parseInt(id) };

            apolloClient
                .query({
                    query: CartWithArticlePivotsGql,
                    fetchPolicy: 'no-cache',
                    variables
                })
                .then(({ data }) => resolve(data.CO_ShoppingCart))
                .catch(err => reject(err));
        });
    },
    //     if (cart === undefined) throw new Error('required argument is missing');
    //
    //     cart = _.removeDeepByKey(cart, '__typename');
    //     return new Promise((resolve, reject) => {
    //         apolloClient
    //             .mutate({
    //                 mutation: CreateCartGql,
    //                 variables: { cart }
    //             })
    //             .then(({ data }) => {
    //                 apolloClient.clearStore();
    //                 resolve(data.CO_CreateCart);
    //             })
    //             .catch(err => reject(err));
    //     });
    // },
    save: shoppingCart => {
        if (shoppingCart === undefined) throw new Error('required argument is missing');

        shoppingCart = _.removeDeepByKey(shoppingCart, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: SaveCartGql,
                    variables: { shoppingCart }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_SaveShoppingCart);
                })
                .catch(err => reject(err));
        });
    },
    processCartArticlePaginationBulkAction: (action, data, cartId) => {
        return new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .mutate({
                    mutation: ProcessCartArticlePaginationBulkActionGql,
                    variables: {
                        action,
                        filters,
                        selection: {
                            type: _.get(data, 'pageInfo.selection.type', 'inclusive'),
                            identifiers: _.get(data, 'pageInfo.selection.identifiers', []),
                        },
                        order: _.get(data, 'variables.order', 'id'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        cart: parseInt(cartId),
                    },
                })
                .then(({ data }) => resolve(data.CO_ProcessCartArticlePaginationBulkAction))
                .catch(err => reject(err));
        });
    },
    // delete: id => {
    //     if (id === undefined) throw new Error('required argument is missing');
    //
    //     return new Promise((resolve, reject) => {
    //         apolloClient
    //             .mutate({
    //                 mutation: DeleteCartGql,
    //                 variables: { id }
    //             })
    //             .then(({ data }) => {
    //                 apolloClient.clearStore();
    //                 resolve(data.CO_DeleteCart);
    //             })
    //             .catch(err => reject(err));
    //     });
    // }
};
